<div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()"><span aria-hidden="true">&times;</span></button>
    <h4 class="modal-title" id="labelButtons">Link Customer to AZ MVD Now User</h4>
</div>
<div class="modal-body">
    <validation-results [validationResults]="validationResults" *ngIf="showValidationComponent"></validation-results>
    <form [formGroup]="form">
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label title="*" class="required" for="email">Email</label>
                    <input class="mvd_form-control" autocomplete="off" formControlName="email" maxlength="256" />
                    <control-validation-messages control="email"></control-validation-messages>
                </div>
            </div>
        </fieldset>
        <div class="well__footer">
            <div class="btn--group">
                <button class="btn--default" type="button" (click)="reset()">Reset</button>
                <mvm-spinner-btn [isDisabled]="!form.valid || showSaveButtonLoading" [isLoading]="showSearchButtonLoading" [btnText]="'Search'" (clicked)="searchUnlinkedUsers()"></mvm-spinner-btn>
            </div>
        </div>
    </form>
    <ng-container *ngIf="mvdNowUsers">
        <h2>Email Results</h2>
        <p-table [value]="mvdNowUsers" selectionMode="single" [(selection)]="selectedUser" [dataKey]="'id'">
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td [attr.colspan]="2">
                        No unlinked MVD Now users found.
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <th>Email<p-sortIcon [field]="'email'"></p-sortIcon></th>
                    <th>Account Type<p-sortIcon [field]="'issuer'"></p-sortIcon></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
                <tr [pSelectableRow]="user">
                    <td>{{user.email}}</td>
                    <td>{{user.issuer}}</td>
                </tr>
            </ng-template>
        </p-table>
    </ng-container>
</div>
<div class="modal-footer">
    <div class="btn--group">
        <button class="btn--default" type="button" (click)="cancel()">Cancel</button>
        <mvm-spinner-btn [isDisabled]="!selectedUser || showSearchButtonLoading" [isLoading]="showSaveButtonLoading" [btnText]="'Link'" (clicked)="linkCustomerToMvdNowUser()"></mvm-spinner-btn>
    </div>
</div>